module.exports = __webpack_public_path__ + "assets/img/panel-t.98931a17.svg";